/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { EmpJobMapping } from 'src/app/_model/emp-job-mapping';

@Injectable()
export abstract class EmpJobMappingsDaoService implements Resetable {
  public abstract saveEmpJobMappings(
    empJobMappings: EmpJobMapping[]
  ): Promise<void>;
  public abstract getEmpJobMappings(): Promise<EmpJobMapping[]>;
  public abstract getLastUpdatedTeam(): Promise<number>;
  public abstract setLastUpdatedTeam(timestamp: number): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
  
}
